import React, { useState, useCallback, useEffect } from 'react';
import Conexao from '../../Config/conexao';
import axios from 'axios';
import Menu from '../NavbarLaboratorio/navbarlaboratorio';
import { useDropzone } from 'react-dropzone'
import './CadastroAmostra.css';
import { Navbar, Table, Row, Col, Button, Modal, Offcanvas } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
import { BeatLoader, BarLoader } from 'react-spinners';
import { Trash } from 'react-bootstrap-icons';
import { Container, ContainerForm, TextFieldStyled } from "./styles";
export default function ProgramacaoAmostra() {

    const [processo, setProcesso] = useState();
    const [dadosprocesso, setDadosProcesso] = useState();
    const [file, setFile] = useState(null);
    const [tipoamostraselect, setTipoAmostraSelect] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [cargo, setCargo] = useState('');
    const [setor, setSetor] = useState('');
    const [pais, setPais] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [entidadeselected, setEntidadeSelectd] = useState();
    const [obraselectd, setObraSelectd] = useState();
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalTrash, setShowModalTrash] = useState(false);
    const [array, setArray] = useState([]);
    const [lote, setLote] = useState();
    const [amostra, setAmostra] = useState();
    const [isLoading, setIsLoading] = useState();
    const [selectedId, setSelectedId] = useState(0)
    const [name, setName] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadingprocesso, setIsLoadingProcesso] = useState(false);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = array.slice(indexOfFirstItem, indexOfLastItem);
    const [sondagem, setSondagem] = useState('');
    const [dataRegistro, setDataRegistro] = useState('');
    const [dataPrevisaoSaida, setDataPrevisaoSaida] = useState('');
    const [coordenadaX, setCoordenadaX] = useState('');
    const [coordenadaY, setCoordenadaY] = useState('');
    const [coordenadaZ, setCoordenadaZ] = useState('');
    const [profundidadeInicial, setProfundidadeInicial] = useState('');
    const [profundidadeFinal, setProfundidadeFinal] = useState('');
    const [ProcAmosFiltro, setProcessoFiltro] = useState('');
    const [OptionFiltro, setOptionFiltro] = useState('Processo')
    const [localizacao, setLocalizacao] = useState('');
    const [localColeta, setLocalColeta] = useState('');
    const [aplicacao, setAplicacao] = useState('');
    const [responsabilidadeAmostragem, setResponsabilidadeAmostragem] = useState('');
    const [bloqueado, setBloqueado] = useState(true)
    const totalPages = Math.ceil(array.length / itemsPerPage);
    const startPage = Math.max(1, currentPage - 5);
    const endPage = Math.min(totalPages, currentPage + 5);
    const [isLoading1, setIsLoading1] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState();
    const [liClicked, setLiClicked] = useState(false);


    const handleShowSidebar = (index) => {
        setShowSidebar(true);
        //setBackgroundImage(images[index]);

    }
    const handleCloseSidebar = () => {
        setShowSidebar(false);

    }
    const handleSubmit = (event) => {
        event.preventDefault();
        // Verificar se todos os campos foram preenchidos
        if (!firstName || !lastName || !username || !cargo || !setor || !pais || !password || !confirmPassword) {
            alert('Por favor, preencha todos os campos.');
            return;
        } else {
            if (password.length >= 6) {
                if (password !== confirmPassword) {
                    setErrorMessage('As senhas não são iguais');
                } else {
                    setErrorMessage('');

                }
            } else {
                setErrorMessage('A senha tem que ter mais de 6 caracteres');
            }
        };
    }

    useEffect(() => {
        listarDadosGeral()
    }, [])



    async function SalvarCadastroAmotra() {
        setIsLoading(true);
        let tipoamostra;
        if (tipoamostraselect === 'I') {
            tipoamostra = 'Intactas';
        } else if (tipoamostraselect === 'R') {
            tipoamostra = 'Remexida';
        } else if (tipoamostraselect === 'E') {
            tipoamostra = 'Enrocamento';
        } else if (tipoamostraselect === 'AB') {
            tipoamostra = 'Argamassas e Concretos';
        } else if (tipoamostraselect === 'AG') {
            tipoamostra = 'Água';
        } else if (tipoamostraselect === 'B') {
            tipoamostra = 'Betuminoso';
        } else if (tipoamostraselect === 'A') {
            tipoamostra = 'Agregados Inertes';
        } else if (tipoamostraselect === 'RO') {
            tipoamostra = 'Rocha';
        }

        const obj = {
            processo,
            amostra,
            tipoamostraselect,
            tipoamostra,
            entidadeselected,
            obraselectd,
            lote,
            sondagem,
            dataRegistro,
            dataPrevisaoSaida,
            coordenadaX,
            coordenadaY,
            coordenadaZ,
            profundidadeInicial,
            profundidadeFinal,
            localizacao,
            localColeta,
            aplicacao,
            responsabilidadeAmostragem
        };

        const res = await axios.post(Conexao.api + 'SalvarCadastroAmostra.php', obj);

        console.log('SalvarLista', obj)
        console.log(res.data)
        if (res.data.success === true) {
            alert('Login Salvo com Sucesso!')
            setShowModal(false)
            setIsLoading(false);
            resetForm()
        }


    };
    async function listarDadosGeral() {
        try {
            setIsLoading(true);
            const res = await axios.get(Conexao.api + 'ListaCadastroAmostra.php');
            console.log(res.data.result);
            setArray(res.data.result);
            setIsLoading(false);

        } catch (error) {
            console.error(error);
        }
    }

    async function listarDados() {
        setIsLoadingProcesso(true);
        try {//BuscarCadastroProcesso.php
            const res = await axios.get(Conexao.api + 'BuscarCadastroProcesso.php?processo=' + processo);
            console.log(res.data);
            if (res.data.result !== '0') {
                setDadosProcesso(res.data.result);
                setAmostra(res.data.amostra);
                setBloqueado(false);
                setIsLoadingProcesso(false);
            } else {
                alert('Processo não encontrado');
                setIsLoadingProcesso(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoadingProcesso(false);
        }

    }
    async function listarDadosfilter(filt, option) {
        setIsLoadingProcesso(true);
        console.log(filt, option)
        if (filt == "") {
            const res = await axios.get(Conexao.api + 'ListaCadastroAmostra.php');
            console.log(res.data.result);
            setArray(res.data.result);
        }
        try {
            const res = await axios.get(Conexao.api + 'ListaCadastroAmostraFilter.php?filter=' + filt + '&' + 'option=' + option);
            console.log(Conexao.api + 'ListaCadastroAmostraFilter.php?filter=' + filt + 'option=' + option);
            if (res.data.result !== '0') {
                setArray(res.data.result);
                setIsLoadingProcesso(false);
            } else {
                alert('Amostra/Processo não encontrado');
                setIsLoadingProcesso(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoadingProcesso(false);
        }
    }
    const resetForm = () => {

        setProcesso('');
        setAmostra('');
        setTipoAmostraSelect('');
        setEntidadeSelectd('');
        setObraSelectd('');
        setLote('');
        setSondagem('');
        setDataRegistro('');
        setDataPrevisaoSaida('');
        setCoordenadaX('');
        setCoordenadaY('');
        setCoordenadaZ('');
        setProfundidadeInicial('');
        setProfundidadeFinal('');
        setLocalizacao('');
        setLocalColeta('');
        setAplicacao('');
        setResponsabilidadeAmostragem('');
    };
    async function ExcluirAmostra() {


        const res = await axios.get(Conexao.api + 'ExcluirAmostra.php?id=' + selectedId);
        console.log(Conexao.api + 'ExcluirAmostra.php?id=' + selectedId)
        if (res.data.success === true) {
            setShowModalTrash(false)
            alert('Amostra Excluida com Sucesso!')
            //const res = await axios.get(Conexao.api + 'ListaCadastroAmostra.php');
            console.log(res.data.result);
            // setArray(res.data.result);
            listarDadosGeral()

        }

    }
    const handleDateChange = (e) => {
        const date = new Date(e.target.value);
        const formattedDate = date.toISOString().split('T')[0];
        setDataRegistro(formattedDate);
    };


    const handleDateChange2 = (e) => {
        const date = new Date(e.target.value);
        const formattedDate = date.toISOString().split('T')[0];
        setDataPrevisaoSaida(formattedDate);
    };

    const onDrop = useCallback(acceptedFiles => {
        setFile(acceptedFiles[0]);
        console.log(acceptedFiles)
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    if (isLoading) {
        return (
            <div className="home"style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto' }} >
                <div className="banner"  >
                    <div>
                        {/* <Menu /> */}

                        <h2 style={{ textAlign: 'center', marginTop: '60px', color: '#3EBF52' }}>Lista de Cadastro de Amostra</h2>



                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh', marginTop: '0%' }}>
                            <span style={{ color: "#000000", fontSize: '20px' }}>Loading...</span>
                            <BeatLoader color="#FFD700" />



                        </div>






                    </div>
                </div>
            </div>
        );
    }

    return <div className="home">
        <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1300px', minWidth: '1600px' }} >
            <div className="sidebar-button">
                <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
                    <div className="icon-container">
                        <i className="bi bi-list icon-circle"></i>
                    </div>
                </Button>

            </div>
            <div className="language-buttons">
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
                </Button>
                <Button variant="outline" className="rounded-circle">
                    <img src="../Images/BandeiraPortugal.png" alt="Português" />
                </Button>
            </div>
            <div className="sidebar-Text" style={{  marginRight: '10%' }}>
                <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginRight: '20%',marginTop:'10%' }}>Cadastro de Amostra</text>
            </div>

            <Container >
                <ContainerForm>
                    <div class="navbarCadastroAmostra">
                        <div class="navbar-childCadastroAmostra">
                            <button class="btnlogin" onClick={() => setShowModal(true)} style={{ float: 'right', backgroundColor: '#187A40',marginRight:'10%',marginTop:'5%' }}>Cadastro de Amostra</button>
                            <Col style={{ marginRight: '60%' }}>
                                <div style={{ marginLeft: '40%', marginTop: '10%' }}>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" onChange={(f) => setOptionFiltro(f.target.value)} value="Processo" defaultChecked />
                                        <label class="form-check-label" for="inlineRadio1">Processo</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" onChange={(f) => setOptionFiltro(f.target.value)} value="Amostra" />
                                        <label class="form-check-label" for="inlineRadio2">Amostra</label>
                                    </div>
                                    <input
                                        type="text" class="form-control" id="processo" placeholder="filtrar" onChange={(e) => setProcessoFiltro(e.target.value)} value={ProcAmosFiltro} disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13 && OptionFiltro == "") {
                                                setOptionFiltro("Processo")
                                                listarDadosfilter(ProcAmosFiltro, OptionFiltro);
                                                console.log(OptionFiltro)
                                            }
                                            else if (e.keyCode === 13 && OptionFiltro == "Processo") {
                                                setProcessoFiltro(e.target.value);
                                                listarDadosfilter(ProcAmosFiltro, OptionFiltro);
                                                console.log(OptionFiltro)
                                            }
                                            else if (e.keyCode === 13 && OptionFiltro == "Amostra") {
                                                console.log(OptionFiltro)
                                                setProcessoFiltro(e.target.value);
                                                listarDadosfilter(ProcAmosFiltro, OptionFiltro);
                                            }
                                        }}
                                    />
                                </div>
                                <Table style={{ fontSize: '12px', marginLeft: '10%', marginTop: '10%' }}>
                                    <thead striped bordered hover style={{ backgroundColor: '#187A40' }}>
                                        <tr>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Processo</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Amostra</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Sondagem</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Profundidade Inicial</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Profundidade Final</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Tipo Amostra</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Coordenadas X</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Coordenadas Y</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Coordenadas Z</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Lote</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Prev. Saida Lote</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Prof. Inicial</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Prof. Final</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Responsabilidade Amostragem</th>
                                            <th style={{ fontSize: '12px', textAlign: 'center', textShadow: 'none' }}>Visualizar</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {currentItems.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Processo}</td>
                                                <td style={{ fontSize: '10px', textalign: 'center', verticalAlign: 'center', textShadow: 'none' }}>{item.Amostra}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Sondagem}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Profundidade_inicial}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Profundidade_final}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Tipo_Amostra
                                                }</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Coordenadas_X}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Coordenadas_Y}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Coordenadas_Z}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Lote}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Prev_data_saida_lote}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Profundidade_inicial}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Profundidade_final}</td>
                                                <td style={{ fontSize: '10px', textAlign: 'center', textShadow: 'none' }}>{item.Responsabilidade_Amostragem}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <Button variant="danger" style={{ marginLeft: 'auto', marginRight: 'auto', padding: '5px 10px', fontSize: '14px' }} onClick={() => {
                                                        setSelectedId(item.ID);
                                                        setName(item.nome);
                                                        setShowModalTrash(true);
                                                    }}>
                                                        <Trash />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>


                                </Table>
                                <nav aria-label="Navegação de página exemplo">
                                    <ul class="pagination">
                                        <li className="page-item">
                                            <a
                                                className="page-link"
                                                href="#"
                                                aria-label="Anterior"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
                                                }}
                                            >
                                                <span aria-hidden="true">&laquo;</span>
                                                <span className="sr-only">Anterior</span>
                                            </a>
                                        </li>
                                        {Array(endPage - startPage + 1).fill().map((_, index) => {
                                            const pageNumber = startPage + index;
                                            return (
                                                <li className="page-item" key={index}>
                                                    <a
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(pageNumber)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: currentPage === pageNumber ? 'blue' : 'white'
                                                        }}
                                                    >
                                                        {pageNumber}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                        {endPage < totalPages && <li className="page-item"><a className="page-link">...</a></li>}
                                        <li className="page-item">
                                            <a
                                                className="page-link"
                                                href="#"
                                                aria-label="Próximo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentPage(prevPage => prevPage + 1);
                                                }}
                                                style={{ visibility: currentPage === totalPages ? 'hidden' : 'visible' }}
                                            >
                                                <span aria-hidden="true">&raquo;</span>
                                                <span className="sr-only">Próximo</span>
                                            </a>
                                        </li>
                                        <li className="page-item">
                                            <select
                                                className="page-link"
                                                value={itemsPerPage}
                                                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                                style={{ visibility: currentPage === totalPages && currentPage !== 1 ? 'hidden' : 'visible' }}
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={30}>30</option>
                                                <option value={40}>40</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </li>
                                    </ul>

                                </nav>
                            </Col>
                            <Modal show={showModal} onHide={() => { setShowModal(false); resetForm(); }}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Cadastro de Amostra</Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>


                                    <div class="col-md-10 col-lg-10">
                                        <div class="row g-3">
                                            <div class="col-12">
                                                <label for="processo" class="form-label">Processo</label>
                                                <input
                                                    onChange={(e) => setProcesso(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.keyCode === 13) {
                                                            setProcesso(e.target.value);
                                                            listarDados();
                                                        }
                                                    }} type="text" class="form-control" id="processo" placeholder="" required />
                                                {isLoadingprocesso ? (
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh', marginTop: '0%' }}>
                                                        <p>Carregando...</p>
                                                        <BeatLoader color="#FFD700" />
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div class="col-12">
                                                <label for="lote" class="form-label">Lote</label>
                                                <input type="text" class="form-control" id="lote" placeholder="" onChange={(e) => setLote(e.target.value)} value={lote} required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="amostra" class="form-label">Amostra</label>
                                                <input type="text" class="form-control" id="amostra" placeholder="" onChange={(e) => setAmostra(e.target.value)} value={amostra} disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="tipoAmostra" class="form-label">Tipo de Amostra</label>
                                                <select class="form-select" onChange={(e) => setTipoAmostraSelect(e.target.value)} value={tipoamostraselect} id="tipoAmostra" required disabled={bloqueado}>
                                                    <option selected>Selecione...</option>
                                                    <option value="I">INTACTAS</option>
                                                    <option value="R">REMEXIDA</option>
                                                    <option value="E">ENROCAMENTO</option>
                                                    <option value="AB">ARGAMASSAS E CONCRETOS</option>
                                                    <option value="AG">ÁGUA</option>
                                                    <option value="B">BETUMINOSO</option>
                                                    <option value="A">AGREGADOS INERTES</option>
                                                    <option value="RO">ROCHA</option>
                                                </select>
                                            </div>
                                            <div class="col-12">
                                                <label for="obra" class="form-label">Obra</label>
                                                <select value={obraselectd} onChange={e => setObraSelectd(e.target.value)} class="form-select" id="obra" required disabled={bloqueado}>
                                                    <option selected>Selecione...</option>
                                                    {dadosprocesso ? dadosprocesso.map((dados) => (<option key={dados.id} value={dados.DesignacaoObra} > {dados.DesignacaoObra} </option>)) : null}
                                                </select>
                                            </div>
                                            <div class="col-12">
                                                <label for="entidade" class="form-label">Entidade</label>
                                                <select value={entidadeselected} onChange={e => setEntidadeSelectd(e.target.value)} class="form-select" id="entidade" required disabled={bloqueado}>
                                                    <option selected>Selecione...</option>
                                                    {dadosprocesso ? dadosprocesso.map((dados) => (
                                                        <option key={dados.id} value={dados.Entidade}>{dados.Entidade}</option>
                                                    )) : null}
                                                </select>
                                            </div>

                                            <div class="col-12">
                                                <label for="sondagem" class="form-label">Sondagem</label>
                                                <input type="text" class="form-control" id="sondagem" value={sondagem} onChange={e => setSondagem(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="dataRegistro" class="form-label">Data de Registro</label>
                                                <input type="date" class="form-control" id="dataRegistro" value={dataRegistro} onChange={handleDateChange} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="dataPrevisaoSaida" class="form-label">Data de previsão saída</label>
                                                <input type="date" class="form-control" id="dataPrevisaoSaida" value={dataPrevisaoSaida} onChange={handleDateChange2} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="coordenadaX" class="form-label">Coordenada X</label>
                                                <input type="text" class="form-control" id="coordenadaX" value={coordenadaX} onChange={e => setCoordenadaX(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="coordenadaY" class="form-label">Coordenada Y</label>
                                                <input type="text" class="form-control" id="coordenadaY" value={coordenadaY} onChange={e => setCoordenadaY(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="coordenadaZ" class="form-label">Coordenada Z</label>
                                                <input type="text" class="form-control" id="coordenadaZ" value={coordenadaZ} onChange={e => setCoordenadaZ(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="profundidadeInicial" class="form-label">Profundidade Inicial</label>
                                                <input type="text" class="form-control" id="profundidadeInicial" value={profundidadeInicial} onChange={e => setProfundidadeInicial(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="profundidadeFinal" class="form-label">Profundidade Final</label>
                                                <input type="text" class="form-control" id="profundidadeFinal" value={profundidadeFinal} onChange={e => setProfundidadeFinal(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="localizacao" class="form-label">Localização</label>
                                                <input type="text" class="form-control" id="localizacao" value={localizacao} onChange={e => setLocalizacao(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="localColeta" class="form-label">Local da Coleta</label>
                                                <input type="text" class="form-control" id="localColeta" value={localColeta} onChange={e => setLocalColeta(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="aplicacao" class="form-label">Aplicação</label>
                                                <input type="text" class="form-control" id="aplicacao" value={aplicacao} onChange={e => setAplicacao(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                            <div class="col-12">
                                                <label for="responsabilidadeAmostragem" class="form-label">Responsabilidade da Amostragem</label>
                                                <textarea type="text" class="form-control" id="responsabilidadeAmostragem" value={responsabilidadeAmostragem} onChange={e => setResponsabilidadeAmostragem(e.target.value)} placeholder="" required disabled={bloqueado} />
                                            </div>
                                        </div>
                                        <hr class="my-4"></hr>
                                        <button class="w-100 btn btn-primary btn-lg" type="submit" onClick={(e) => SalvarCadastroAmotra(e)}>
                                            {isLoading1 ? (
                                                <>
                                                    <span style={{ color: "#000000", fontSize: '20px' }}>Loading...</span>
                                                    <BeatLoader color="#FFD700" />
                                                </>
                                            ) : (
                                                'Salvar'
                                            )}
                                        </button>
                                    </div>



                                </Modal.Body>
                            </Modal>
                        </div>

                    </div>

                    {/* final */}

                </ContainerForm>
            </Container>

        </div>
    

        <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
            <div className="offcanvas-header">


                <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
            </div>
            <Offcanvas.Body>
                <ul>
                    <li className={`${liClicked ? 'li-slide-right' : ''}`} >
                        <Link to="/app/Laboratorio" style={{ textDecoration: 'none' }}>
                            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
                    </li>
                    {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
                <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                  <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
                </span></Button>
              </li> */}
                    {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
                <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                  <i className="bi bi-chevron-right"></i>
                </span></Button>
              </li> */}
                    {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
                <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                  <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
                </span></Button>
              </li> */}
                </ul>
            </Offcanvas.Body>
        </Offcanvas>
    </div>


}

